export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/caseIH.6a7d8a1d.svg","height":250,"width":250,"blurWidth":0,"blurHeight":0};